import React from 'react';
import styled from 'styled-components';
import { spacing } from '../style/theme';
var Flag = styled.div.withConfig({
  displayName: "Flag",
  componentId: "yermlt-0"
})(["display:flex;align-items:center;"]);
var FlagImage = styled.div.withConfig({
  displayName: "Flag__FlagImage",
  componentId: "yermlt-1"
})(["flex:0 1 48px;margin-right:", "px;"], spacing.base);
var FlagContent = styled.div.withConfig({
  displayName: "Flag__FlagContent",
  componentId: "yermlt-2"
})(["flex:1 0;"]);

var FlagStyled = function FlagStyled(_ref) {
  var image = _ref.image,
      children = _ref.children;
  return React.createElement(Flag, null, React.createElement(FlagImage, null, React.createElement("img", {
    style: {
      marginBottom: 0
    },
    src: image.src,
    alt: image.alt
  })), React.createElement(FlagContent, null, children));
};

export default FlagStyled;